import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Hand, Gift, Star } from 'lucide-react';
import { AnimatedFunnel } from '../visualizations/AnimatedFunnel';
export function Slide12Measurement() {
  const funnelStages = [{
    label: 'Observation',
    percentage: 100,
    icon: Eye
  }, {
    label: 'Catch',
    percentage: 68,
    icon: Hand
  }, {
    label: 'Redeem',
    percentage: 42,
    icon: Gift
  }, {
    label: 'Review',
    percentage: 35,
    icon: Star
  }];
  return <div className="flex flex-col h-full justify-center max-w-7xl mx-auto w-full" data-id="element-156">
      <motion.h2 className="text-5xl font-bold text-white mb-12 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-157">
        Measurement <span className="text-[#4fd1c5]" data-id="element-158">(The Data Engine)</span>
      </motion.h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-159">
        {/* Funnel Visualization */}
        <div data-id="element-160">
          <AnimatedFunnel stages={funnelStages} data-id="element-161" />
        </div>

        {/* Metrics/Insights */}
        <div className="space-y-6" data-id="element-162">
          <h3 className="text-2xl font-bold text-[#ffd700] mb-6" data-id="element-163">
            Key Insights
          </h3>
          {['Real-time preference data & sentiment analysis', 'Geodata mapping & demographic breakdown', 'Conversion tracking from physical to digital', 'Full attribution modeling for ROI calculation'].map((item, i) => <motion.div key={i} initial={{
          x: 20,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} transition={{
          delay: 1 + i * 0.1
        }} className="p-6 rounded-xl bg-white/5 border border-white/10 text-lg text-white/90 flex items-start gap-4" data-id="element-164">
              <div className="w-2 h-2 rounded-full bg-[#4fd1c5] mt-2.5 flex-shrink-0" data-id="element-165" />
              {item}
            </motion.div>)}
        </div>
      </div>
    </div>;
}